module.exports = __webpack_public_path__ + "img/cave99.65a607bb.jpg";